import * as Roles from '@/store/roles';

export const inspectionActionsPermissions = {
  addInspection: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  getInspection: [Roles.Any],
  addInspectionParticipant: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  updateInspectionParticipantSelection: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  saveInspectionProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setInspectionProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  fetchInspectionPdfUrl: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  syncInspection: [Roles.Any],
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionActionsPermissions.js